import * as scheduleTabService from '@/services/schedule-tabs-service.js'
// import router from '@/router'

// Break schedules related state out

// import actions from './actions';
// import getters from './getters';
// import mutations from './mutations';
// import state from './state';

// eslint-disable-next-line no-unused-vars
import Vue from 'vue'
import ScheduleTypes from '@/constants/schedule-types'
import { getPreferenceValueFromObjElseDefault } from '@/views/brokerage-admin/broker-preferences'

const setShowImportWizard = (context, payload) => {
  context.commit('SET_SHOW_IMPORT_WIZARD', payload)
}

const setImportWizardData = (context, payload) => {
  context.commit('SET_IMPORT_WIZARD_DATA', payload)
}
const setScheduleTabs = (context, payload) => {
  context.commit('SET_SCHEDULE_TABS', payload)
}
const addScheduleTab = (context, payload) => {
  const tabs = context.getters.getScheduleTabs
  tabs.push(payload)
  context.commit('SET_SCHEDULE_TABS', tabs)
}
const updateScheduleTab = (context, payload) => {
  const tabs = context.getters.getScheduleTabs
  const index = tabs.findIndex(tab => tab.scheduleTabId === payload.scheduleTabId)
  context.commit('SET_SCHEDULE_TABS', [...tabs.slice(0, index), payload, ...tabs.slice(index + 1)])
}
const removeScheduleTab = (context, payload) => {
  const tabs = context.getters.getScheduleTabs
  const index = tabs.findIndex(tab => tab.scheduleTabId === payload)
  tabs.splice(index, 1)
  context.commit('SET_SCHEDULE_TABS', tabs)
}
// This code is specific to duplicate tabs
const loadCustomScheduleTabs = async (context, accountCode) => {
  try {
    const tabs = await scheduleTabService.getScheduleTabs(accountCode)
    context.commit('SET_SCHEDULE_TABS', tabs)
  } catch (ex) {
    console.error('Failed to load apps')
  }
}
const setScheduleFields = (context, { type, fields }) => {
  context.commit('SET_SCHEDULE_FIELDS', {
    type,
    fields,
  })
}
const setCurrentTabId = (context, payload) => {
  context.commit('SET_CURRENT_TAB_ID', payload)
}

const actions = {
  setShowImportWizard,
  setImportWizardData,
  addScheduleTab,
  removeScheduleTab,
  updateScheduleTab,
  setScheduleTabs,
  loadCustomScheduleTabs,
  setScheduleFields,
  setCurrentTabId,
}

// Default Schedules that are available to the schedules module
const allAvailableSchedules = () => {
  const allSchedules = ScheduleTypes
  const scheduleKeys = Object.keys(allSchedules)
  return scheduleKeys.map(key => allSchedules[key]).filter(sched => !!sched.frontend)
}

// More refactoring can be done here, but will circle back.
const schedulesToShowPreference = (state, getters, rootState, rootGetters) => {
  const savedPreference = rootGetters.getPreference('SCHEDULES')
  const defaultSchedulesToShow = [
    ScheduleTypes.PROPERTY.frontend,
    ScheduleTypes.AUTO.frontend,
    ScheduleTypes.DRIVERS.frontend,
    ScheduleTypes.EQUIPMENT.frontend,
    ScheduleTypes.WORKERS_COMP.frontend,
  ]
  const defaultAsString = JSON.stringify(defaultSchedulesToShow)

  const returned = getPreferenceValueFromObjElseDefault(savedPreference, defaultAsString)
  const schedulePreferences = returned ? JSON.parse(returned) : null
  return schedulePreferences
}

// getAllScheduleTabsToShow
// Takes preferences and additional duplicate tabs into account
// Returns schedules in the shape of a ScheduleType (additional/duplicates may have different display names)
const getAllScheduleTabsToShow = (state, getters) => {
  // schedule is a ScheduleType
  const scheduleIsIncludedInPreferences = schedule => {
    if (!getters.schedulesToShowPreference) {
      return false
    }
    const show = getters.schedulesToShowPreference.includes(schedule.frontend)
    return show
  }

  const allAvailableSchedules = getters.allAvailableSchedules
  const schedules = allAvailableSchedules.filter(sched => {
    return scheduleIsIncludedInPreferences(sched)
  })

  // Adds Duplicate tabs in
  getters.getScheduleTabs.forEach(tab => {
    const matchIndex = schedules.findIndex(schedule => schedule.backend === tab.scheduleType)
    if (matchIndex !== -1) {
      const newSchedule = {
        ...schedules[matchIndex],
        scheduleTabId: tab.scheduleTabId,
        display: tab.tabName,
      }
      schedules.splice(matchIndex + 1, 0, newSchedule)
    }
  })
  return schedules
}

// Only the additional duplicate schedule tabs
const getScheduleTabs = state => state.scheduleTabs
const getShowImportWizard = state => state.showImportWizard || false
const getImportWizardData = state => state.importWizardData || {}
const getWizardScheduleType = state => state.importWizardData?.frontend
const getWizardTitle = state => state.importWizardData?.title
const getWizardAreRecords = state => state.importWizardData?.areRecords
const getWizardGridLabels = state => state.importWizardData?.gridLabels || []
const getWizardMultipleSheets = state => state.importWizardData?.multipleSheets || false
const getScheduleFields = state => type => state.scheduleFields?.[type] || []

const getCurrentScheduleTabId = state => {
  const tabId = state.currentScheduleTabId
  return tabId
}

const getters = {
  schedulesToShowPreference,
  allAvailableSchedules,
  getAllScheduleTabsToShow,
  getScheduleTabs,
  getShowImportWizard,
  getImportWizardData,
  getWizardScheduleType,
  getWizardTitle,
  getWizardAreRecords,
  getWizardGridLabels,
  getWizardMultipleSheets,
  getScheduleFields,
  getCurrentScheduleTabId,
}

const SET_SHOW_IMPORT_WIZARD = (state, payload) => {
  Vue.set(state, 'showImportWizard', payload)
}

// Some of our code needs the tab id to be a number, if populated.
// By default, the route param is a string.
// Converting it to a number causes undefined -> NaN which is also problematic
const SET_CURRENT_TAB_ID = (state, payload) => {
  if (payload == null) {
    Vue.set(state, 'currentScheduleTabId', payload)
  } else {
    const numberTab = +payload
    Vue.set(state, 'currentScheduleTabId', numberTab)
  }
}
const SET_IMPORT_WIZARD_DATA = (state, payload) => {
  Object.keys(payload).forEach(key => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.importWizardData.hasOwnProperty(key)) {
      Vue.set(state.importWizardData, key, payload[key])
    }
  })
}
const SET_SCHEDULE_TABS = (state, payload) => {
  // Object.assign(state, payload)
  if (payload == null) {
    Vue.set(state, 'scheduleTabs', [])
  } else {
    Vue.set(state, 'scheduleTabs', payload)
  }
}

const SET_SCHEDULE_FIELDS = (state, { type, fields }) => {
  if (!state.scheduleFields) {
    Vue.set(state, 'scheduleFields', {})
  }

  if (fields == null) {
    Vue.set(state.scheduleFields, type, [])
  } else {
    Vue.set(state.scheduleFields, type, fields)
  }
}

const mutations = {
  SET_SHOW_IMPORT_WIZARD,
  SET_IMPORT_WIZARD_DATA,
  SET_SCHEDULE_TABS,
  SET_SCHEDULE_FIELDS,
  SET_CURRENT_TAB_ID,
}
// Model would need to match `DigitalAppModel` on the backend
const state = {
  scheduleTabs: [],
  currentScheduleTabId: undefined,
  showImportWizard: false,
  importWizardData: {
    type: undefined,
    frontend: undefined, // same as type above
    typeObject: undefined, // Full ScheduleTypeObject (includes: {frontend, display, scheduleTabId})
    title: undefined,
    areRecords: false,
    gridLabels: [],
    multipleSheets: false,
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
